<template>
  <div class="message">
    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="title">消息</div>
      <div class="filter-btn">
        <svg viewBox="0 0 24 24" class="eye-icon"><path d="M2 12 Q8 4 12 4 Q16 4 22 12 Q16 20 12 20 Q8 20 2 12 Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" stroke-width="2"/></svg>
        <span>显示未读</span>
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-state">
      <img :src="emptyImg" class="empty-img" alt="暂无数据" />
      <div class="empty-text">暂无数据,下拉刷新</div>
    </div>
  </div>
</template>

<script>
const emptyImg = require('@/assets/icons/empty.png')

export default {
  name: 'Message',
  data() {
    return { emptyImg }
  }
}
</script>

<style scoped>
.message {
  background: #F3F8FB;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(125 * var(--w));
  background: #fff;
  border-bottom: 1px solid #eaeaea;
}
.title {
  font-size: calc(46 * var(--w));
  font-weight: 500;
  color: #323233;
}
.filter-btn {
  position: absolute;
  right: calc(49 * var(--w));
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: calc(8 * var(--w));
  font-size: calc(28 * var(--w));
  color: #ff976a;
}
.eye-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}
.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.empty-img {
  width: calc(230 * var(--w));
  height: auto;
  object-fit: contain;
}
.empty-text {
  margin-top: calc(56 * var(--w));
  font-size: calc(40 * var(--w));
  color: #323233;
}
</style>



// WEBPACK FOOTER //
// src/pages/Message.vue